import { supabase } from "../supabaseClient";

const forbiddenSymbols = ["insert", "upsert", "update", "delete"];
let guardInstalled = false;

function isVisitorContext() {
  if (typeof window === "undefined") return false;
  const path = window.location?.pathname || "";
  const role = window.localStorage?.getItem?.("mudo:userRole") || "";
  return (
    role === "visitor" ||
    path.startsWith("/discover") ||
    path.startsWith("/ceramics/discover") ||
    path.startsWith("/visitor")
  );
}

export function guardVisitorSupabase() {
  if (guardInstalled || !supabase) return;
  guardInstalled = true;

  const originalFrom = supabase.from.bind(supabase);

  supabase.from = (table: string) => {
    const query = originalFrom(table);
    if (table === "workshops") {
      const forbiddenQuery = query as unknown as Record<string, any>;
      forbiddenSymbols.forEach((action) => {
        const originalMethod = forbiddenQuery[action];
        if (typeof originalMethod === "function") {
          forbiddenQuery[action] = (...args: any[]) => {
            if (isVisitorContext()) {
              const err = new Error(
                "Visitor world attempted to write to workshops - forbidden"
              );
              if (import.meta.env.DEV) {
                console.error("[visitorSupabaseGuard]", err.message);
              }
              throw err;
            }
            return originalMethod.apply(forbiddenQuery, args);
          };
        }
      });
    }
    return query;
  };
}

guardVisitorSupabase();
